module.exports = __webpack_public_path__ + "img/icon_arrow-left_white.20d32762.svg";